/**
 * SelectLang - 语言切换组件
 *
 * 直接使用 Umi Max 内置 SelectLang 组件，不做额外包装。
 * 内置组件已处理 setLocale + selectedLang 状态更新。
 */

import { SelectLang as UmiSelectLang } from '@umijs/max';
import React from 'react';

const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export default SelectLang;
